import { type ReactNode, createContext, useContext } from "react";

import type { Currency } from "@/Apollo/schema";
import { toUrlCurrency } from "@/features/display-currency/currency-url";

const PageDisplayCurrencyContext = createContext<Currency | undefined>(
  undefined
);

/**
 * The currency the server rendered this page's prices in (WHO-6199), from the page's
 * `displayCurrency` prop: set by the product and search pages for a `?currency=` address while
 * the gate is on, absent everywhere else. Mounted once, in `_app`.
 */
export const PageDisplayCurrencyProvider = ({
  value,
  children,
}: {
  value: unknown;
  children: ReactNode;
}) => (
  <PageDisplayCurrencyContext.Provider
    value={toUrlCurrency(value) ?? undefined}
  >
    {children}
  </PageDisplayCurrencyContext.Provider>
);

/**
 * What `useDisplayCurrency` answers before the store has read the cookie, so the first render in
 * the browser asks for the prices the server already fetched: the same Apollo and react-query
 * keys, no refetch, and no euros painted first.
 */
export const usePageDisplayCurrency = () =>
  useContext(PageDisplayCurrencyContext);
